import constants from 'constants/index'

const changeStatus = (status) => {
  return status === constants.serviceCategory.ACTIVE_STATUS
    ? 'Inativar'
    : 'Ativar'
}

export default changeStatus
